<template>
  <ValidationObserver v-slot="{ handleSubmit, invalid ,reset}" ref="observer">
    <artisio-modal scrollable size="lg" :visible="modal && modal.show" @hidden="onHidden" :content-in-form="false"
                   :title="$t('Activities')" :hide-footer="true" modal-class="mobile-full-screen">
      <div class="modal-height">
        <ActivityList :for="'invoice'"
                      :actions="actions"
                      :value-visualizer="valueVisualizer"
                      :actions-to-hide-details-button="['cancelled.invoice','mark_collected','unmark_collected', 'unpaid.invoice','signed_by_buyer', 'signed_by_staff']"
                      :actions-to-search="actionsToSearch"
                      :has-search="true">
          <template slot="modal-body(update.invoice_miscellaneous_items)" slot-scope="{activity}">
            <activity-miscellaneous-table :activity="activity"/>
          </template>
          <template v-slot:text="{activity}">
            {{ actions[activity.action] ? actions[activity.action].message : activity.action }}
          </template>
        </ActivityList>
      </div>
    </artisio-modal>
  </ValidationObserver>
</template>

<script>
  import ArtisioModal from "@/core/components/artisio-modal/ArtisioModal";
  import {createNamespacedHelpers} from "vuex";
  import invoicesActivityHelper from "@/modules/invoices/invoiceActivityHelper";
  import ActivityList from "@/modules/activities/ActivityList";
  import ActivityMiscellaneousTable from "@/modules/receipt/view/activities/ActivityMiscellaneousTable";

  const {mapState, mapActions} = createNamespacedHelpers('activities');
  export default {
    name: "InvoiceActivitiesModal",
    components: {ArtisioModal, ActivityList, ActivityMiscellaneousTable},
    data() {
      return {
        showDetailsModal: false,
        actions: invoicesActivityHelper.actions,
        actionsToSearch:
            [
              {key: 'overdue_invoice_notification', text: this.$i18n.t('Overdue Email Send')},
              {key: 'unpaid_invoice_notification', text: this.$i18n.t('Unpaid Email Send')},
              {key: 'collection_note_created', text: this.$i18n.t('Collection Note Created')},
              {key: 'signed_by_staff', text: this.$i18n.t('Collection note was signed by staff')},
              {key: 'signed_by_buyer', text: this.$i18n.t('Collection note was signed by buyer')},
            ]
      }
    },
    computed: {
      ...mapState({
        modal: state => state.tableData[state.tableSource],
      })
    },
    methods: {
      ...mapActions(['hideActivitiesModal']),
      valueVisualizer: invoicesActivityHelper.valueVisualizer,
      onHidden() {
        this.hideActivitiesModal();
      },
    },
  }
</script>

<style scoped>
  .modal-height {
    height: 60em
  }
</style>
